import { ReactNode } from 'react';
import { ReactComponent as Cosco } from '../../../assets/service-logos/cosco.svg';
import { ReactComponent as Evergreen } from '../../../assets/service-logos/evergreen.svg';
import { ReactComponent as YangMing } from '../../../assets/service-logos/yangming.svg';
import { ReactComponent as Pil } from '../../../assets/service-logos/pil.svg';
import { ReactComponent as Msc } from '../../../assets/service-logos/msc.svg';
import { ReactComponent as Hl } from '../../../assets/service-logos/hl.svg';
import { ReactComponent as Hmm } from '../../../assets/service-logos/hmm.svg';
import { ReactComponent as CmaCgm } from '../../../assets/service-logos/cma-cgm.svg';
import styles from './ScheduleTable.module.scss';

type Logos = {
  [key: string]: ReactNode[];
};

const logos: Logos = {
  'FAR EAST': [
    <Cosco key="Cosco" />,
    <Evergreen key="Evergreen" />,
    <YangMing key="YangMing" />,
    <Pil key="Pil" />,
  ],
  'FAR EAST-INDIA-LATIN AMERICA': [<Hmm key="Hmm" />],
  'MSC NORTH EUROPE': [<Msc key="MSC" />, <Hl key="Hapag Lloyd" />],
  'PLATA SERVICE': [<CmaCgm key="CmaCgm" />],
};

export const getServiceCell = (service: string): ReactNode | string => {
  return logos[service] ? (
    <div className={styles.serviceColumn}>
      <div>{service}</div>
      <div className={styles.logos}>{logos[service]}</div>
    </div>
  ) : (
    service
  );
};
